<div class="filter">
  <div
    *ngIf="filterStatuses"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'statuses'"
      [filter]="filterStatuses">
    </app-filter-select>
  </div>
  <div
    *ngIf="filter2fa"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'2fa'"
      [filter]="filter2fa">
    </app-filter-select>
  </div>
  <div
    *ngIf="filterRoles"
    class="filter__item">
    <app-filter-select
      [filterTitle]="'roles'"
      [filter]="filterRoles">
    </app-filter-select>
  </div>
  <div
    class="filter__item">
    <app-period
      [filterStart]="filterStart"
      [filterEnd]="filterEnd"
      title="{{'FILTERS.PERIOD' | translate}}">
    </app-period>
  </div>
</div>
